<template>
  <div
    class="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
  >
    <div
      class="dark:bg-ontick-graphite-500 overflow-hidden rounded-lg bg-white shadow"
    >
      <div class="px-4 py-5 sm:p-6">
        <span class="flex items-center justify-center"
          ><img class="" :src="data.url" :alt="data.description"
        /></span>
      </div>
      <div class="dark:bg-ontick-steel-500 bg-gray-50 px-4 py-4 sm:px-6">
        {{ data.description }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
  },
};
</script>

<style></style>
